module.exports = __webpack_public_path__ + "images/248074ffdeeeaeffed9c5db35f35fe45.svg";